import store from '@/store';
import {FETCH_ARTICLE, FETCH_RELATED_ARTICLES, SELECT_ARTICLE} from '@/store/actions/article.actions';
import { isDefined } from '@/common/utils/utils';

export const ArticleSelectedGuard = (to, from, next) => {
  const articleSlug = to.params.article;
  const article = store.getters.getArticleBySlug(articleSlug);

  store.dispatch(SELECT_ARTICLE, articleSlug);

  if (!isDefined(article)) {
    store.dispatch(FETCH_ARTICLE, articleSlug).then(
      (article) => {
        store.dispatch(FETCH_RELATED_ARTICLES, article.slug);
      }
    );
  } else {
    // load the related articles
    store.dispatch(FETCH_RELATED_ARTICLES, article.slug);
  }

  return next();
};

